// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kVvr","image":"Header_image__lIy7C","name":"Header_name__37Tne","info":"Header_info__NjDgV","infoRow":"Header_infoRow__1iMqy"};